import { Component, OnInit, Input } from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";

import { PatientPortalService } from '../patient-portal.service';
import { PatientService } from '../../patient/patient.service';
import {CommMethodEnum} from '../../../models/enum/comm-method.enum';
import { CommLocationEnum } from 'src/app/models/enum/comm-location.enum';
import { StaticDataService } from 'src/app/services/static-data.service';
import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';

@Component({
  standalone: false,
  selector: 'app-patient-portal-contacts',
  templateUrl: './patient-portal-contacts.component.html',
  styleUrls: ['./patient-portal-contacts.component.css']
})
export class PatientPortalContactsComponent implements OnInit {

  @Input() disableSaveButton: boolean = false;
  @Input() PatientId: any;
  @Input() PatientContact: any;
  @Input() PatientAddress: any;

  activeIndex: number = 0;
  PatientContacts: any[] = [];
  dataPatientContactObjs: any[] = [];

  isLoading: boolean = false;

  enumContactMethods: any[] = [];
  enumContactRelationships: any[] = [];
  stateListEnums: EnumValidValueItemModel[] = [];

  enumRelationshipName: string = 'enumPatientContactType';
  enumContactMethod = 'enumCommMethod';
  enumState = 'enumStateProvince';
  enumHomeAddressType = '00000008-1000-0000-0000-000000000001';

  constructor(
    private infoGrabberService: PatientPortalService,
    private patientService: PatientService,
    private snackBar: MatSnackBar,
    private staticDataService: StaticDataService,
  ) { }

  ngOnInit() {
    if (!this.staticDataService.isReady) {
      this.isLoading = true;
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.init();
        }
      });
    } else {
      this.init();
    }

  }

  getPatientContacts(patientId: string) {
    let promise = new Promise((resolve, reject) => {
      this.patientService.getPatientContacts(patientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  displayMessage(type, message) {
    this.snackBar.open(message, type, {
      duration: 3000,
      verticalPosition: "top"
    });
  }

  init() {

    this.isLoading = true;

    let promises = [
      this.getPatientContacts(this.PatientId),
      //this.getEnumByName(this.enumRelationshipName),
      //this.getEnumByName(this.enumContactMethod),
    ];

    this.enumContactRelationships = this.staticDataService.getValidValueItemsByValidValueName(this.enumRelationshipName);
    this.enumContactMethods = this.staticDataService.getValidValueItemsByValidValueName(this.enumContactMethod);
    this.stateListEnums = this.staticDataService.getValidValueItemsByValidValueName(this.enumState);

    Promise.all(promises).then((results: any[]) => {

      this.PatientContacts = results[0];

      let contactPromises = [];
      this.PatientContacts.forEach(patientContact => {
        contactPromises.push(this.analyzeContact(patientContact));
      });

      Promise.all(contactPromises)
        .then((contactResults: any[]) => {
          this.dataPatientContactObjs = contactResults;
          this.isLoading = false;
        }, err => {
          console.log(err);
          this.isLoading = false;
          this.displayMessage("Error", "Something went wrong");
        });


      this.isLoading = false;
    }, err => {
      console.log(err);
      this.isLoading = false;
      this.displayMessage("Error", "Something went wrong");
    });

  }

  analyzeContact(dataPatientContact) {

    let promise = new Promise((resolve, reject) => {

      var dataContact = JSON.parse(JSON.stringify(dataPatientContact.dataContact));
      var addressArray = JSON.parse(JSON.stringify(dataContact.dataAddresses));
      var communicationArray = JSON.parse(JSON.stringify(dataContact.dataContactComms));

      var contactObj = {
        dataPatientContact: JSON.parse(JSON.stringify(dataPatientContact)),
        dataContact: dataContact,
        dataAddress: {},
        dataComm: {},
      };

      var contactAddress;
      var contactComm;

      var createPromises = [];
      var createAddress: boolean = false;
      var createContactMethodPhone: boolean = true;

      if (addressArray.length === 0) {
        createAddress = true;
        createPromises.push(this.createAddress(dataContact.ContactId));
      } else {
        var address = addressArray[0];
        addressArray.forEach(dataAddress => {
          if (dataAddress.enumAddressCategoryID === this.enumHomeAddressType) {
            address = dataAddress;
          }
        });
        contactAddress = JSON.parse(JSON.stringify(address));
      }

      if (communicationArray.length !== 0) {

        var communicationMethodPhone;

        communicationArray.forEach(dataCommunication => {

          if (dataCommunication.enumCommMethodID?.toLowerCase() === CommMethodEnum.Mobile.toLowerCase() && dataCommunication.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase()) {
            communicationMethodPhone = dataCommunication;
            createContactMethodPhone = false;
          }

          if (dataCommunication.enumCommMethodID?.toLowerCase() === CommMethodEnum.Phone.toLowerCase() && dataCommunication.enumCommLocationID?.toLowerCase() === CommLocationEnum.HOME.toLowerCase() && createContactMethodPhone) {
            communicationMethodPhone = dataCommunication;
            createContactMethodPhone = false;
          }

        });

        if (communicationMethodPhone) {
          contactComm = JSON.parse(JSON.stringify(communicationMethodPhone));
        } else {
          createPromises.push(this.createContactMethod(CommLocationEnum.HOME, CommMethodEnum.Mobile, dataContact.ContactId));
        }

      } else {
        createPromises.push(this.createContactMethod(CommLocationEnum.HOME, CommMethodEnum.Mobile, dataContact.ContactId));
      }

      if (createPromises.length) {

        Promise.all(createPromises).then((createResults: any[]) => {

          var index = 0;
          if (createAddress) {
            contactAddress = createResults[index];
            index++;
          }

          if (createContactMethodPhone) {
            contactComm = createResults[index];
            index++;
          }

          contactObj.dataAddress = contactAddress;
          contactObj.dataComm = contactComm;

          resolve(contactObj);

        }, err => {
          console.log(err);
          this.displayMessage("Error", "Something went wrong");
        });

      } else {
        contactComm.isPreferred = true;
        contactObj.dataAddress = contactAddress;
        contactObj.dataComm = contactComm;
        resolve(contactObj);
      }

    });

    return promise;
  }

  onAddContactPressed() {

    this.isLoading = true;

    this.createDataPatientContact()
      .then(newPatientContact => {

        this.analyzeContact(newPatientContact)
          .then((contactObj) => {
            this.dataPatientContactObjs.push(contactObj);
            this.isLoading = false;
            this.activeIndex = this.dataPatientContactObjs.length - 1;
          }, err => {
            console.log(err);
            this.isLoading = false;
            this.displayMessage("Error", "Something went wrong");
          })


      }, err => {
        this.isLoading = false;
        console.log(err);
        this.displayMessage("Error", "Something went wrong");
      });
  }

  createDataPatientContact() {
    let promise = new Promise((resolve, reject) => {
      this.patientService.getNewEmergencyContact(this.PatientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getEnumByName_DEPRECATED(enumName: string) {
    let promise = new Promise((resolve, reject) => {
      this.infoGrabberService.getValidValueByName(enumName)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  createAddress(contactID: string) {
    let promise = new Promise((resolve, reject) => {
      this.patientService.getNewContactAddress(contactID)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  createContactMethod(location: string, type: string, contactId: string) {
    let promise = new Promise((resolve, reject) => {
      this.patientService.getNewCommForPatientContact(contactId)
        .subscribe(response => {
          response.enumCommMethodID = type;
          response.enumCommLocationID = location;
          resolve(response);
        }, reject);
    });
    return promise;
  }

  saveDataContact(dataContact) {
    let promise = new Promise((resolve, reject) => {
      this.patientService.saveDataContact(this.PatientId, dataContact)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  saveAddressDetails(addressObj: any) {
    let promise = new Promise((resolve, reject) => {
      this.patientService.saveContactAddress(addressObj)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  saveCommunicationDetails(communicationObj: any) {
    let promise = new Promise((resolve, reject) => {
      this.patientService.saveContactMethod(communicationObj)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  public saveFromAllWindows() {
    let promise = new Promise((resolve, reject) => {
      let promises = [];
      this.dataPatientContactObjs.forEach(dataPatientContactObj => {
        promises.push(this.saveSinglePatientContactObj(dataPatientContactObj));
      });

      Promise.all(promises).then((results) => {
        resolve(null);
      }, err => {
        reject();
      });
    });
    return promise;
  }

  savePatientContacts() {
    let promise = new Promise((resolve, reject) => {

      this.isLoading = true;

      let promises = [];
      this.dataPatientContactObjs.forEach(dataPatientContactObj => {
        promises.push(this.saveSinglePatientContactObj(dataPatientContactObj));
      });

      Promise.all(promises).then((results) => {
        this.isLoading = false;
        this.init();
      }, err => {
        console.log(err);
        this.isLoading = false;
        this.displayMessage("Error", "Something went wrong");
      });

    });
    return promise;
  }

  saveSinglePatientContactObj(patientContactObj) {
    let promise = new Promise((resolve, reject) => {

      var dataPatientContactClone = JSON.parse(JSON.stringify(patientContactObj.dataPatientContact));
      dataPatientContactClone.dataContact = null;

      var contactClone = JSON.parse(JSON.stringify(patientContactObj.dataContact));
      contactClone.dataAddresses = [];
      contactClone.dataContactComms = [];

      var addressClone = JSON.parse(JSON.stringify(patientContactObj.dataAddress));
      var phoneClone = JSON.parse(JSON.stringify(patientContactObj.dataComm));
      phoneClone.isPreferred = true;
      contactClone.dataAddresses.add(addressClone);
      contactClone.dataContactComms.add(phoneClone);
      let promises = [
        this.savePatientContact(dataPatientContactClone),
        this.saveDataContact(contactClone),
      ];

      Promise.all(promises).then(resolve, reject);
    });
    return promise;
  }

  savePatientContact(patientContact) {
    let promise = new Promise((resolve, reject) => {
      this.patientService.savePatientContact(patientContact)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  markAsDeleted(contactObj) {
    contactObj.dataPatientContact.xauditDeleted = true;
    this.savePatientContacts();
  }

  sameAddressChange(contactAddress) {
    console.log("Copy address: ", this.PatientAddress);
    contactAddress.Address1 = this.PatientAddress.Address1;
    contactAddress.Address2 = this.PatientAddress.Address2;
    contactAddress.Address3 = this.PatientAddress.Address3;
    contactAddress.City = this.PatientAddress.City;
    contactAddress.PostCode = this.PatientAddress.PostCode;
    contactAddress.State = this.PatientAddress.State;
    contactAddress.enumStateProvinceID = this.PatientAddress.enumStateProvinceID;
    contactAddress.Suburb = this.PatientAddress.Suburb;
    contactAddress.addrDescription = this.PatientAddress.addrDescription;
    contactAddress.enumAddressCategoryID = this.PatientAddress.enumAddressCategoryID;
    contactAddress.enumCountryID = this.PatientAddress.enumCountryID;
    contactAddress.typeDescription = this.PatientAddress.typeDescription;

  }

}
